// extracted by mini-css-extract-plugin
export default {"main":"Audio_main__TufDh","audioPlayer":"Audio_audioPlayer__OixFZ"};